// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2GLbA","containerItemsCenter":"Skeleton_containerItemsCenter__2wTEH"};